import Batch from "../../Models/Batch";
import Patient from "../../Models/Patient";
import CompWellnessPatient from "../../Models/CompWellnessPatient";

export const DetermineOutstandingPatients = (lumiPatients: Patient[], batches: Batch[]): Patient[] => {

    // First gather a list of all patients that are batched
    var specimenIdsInBatches: string[] = [];

    batches.forEach(batch => {

        var specimenIdsInBatch = batch.specimens.map(specimen => specimen.specimenId);

        specimenIdsInBatch.forEach(batchSpecimenId => {
            var index = specimenIdsInBatches.findIndex(specimenId => specimenId === batchSpecimenId);
            if (index === -1) specimenIdsInBatches.push(batchSpecimenId);
        });
    });

    // Then create a list of specimens that aren't batched from the first list
    var patientsNotInBatches = lumiPatients.filter(patient => !specimenIdsInBatches.includes(patient.sampleId));

    // Then create a list of specimens that that have not been reported as error
    var patientsNotReportedInError = patientsNotInBatches.filter(patient => patient.sampleErrorNote === "");

    return patientsNotReportedInError;
}

export const DetermineOutstandingCompWellnessPatients = (compWellnessPatients: CompWellnessPatient[], batches: Batch[]): CompWellnessPatient[] => {

    // First gather a list of all patients that are batched
    var specimenIdsInBatches: string[] = [];

    batches.forEach(batch => {

        var specimenIdsInBatch = batch.specimens.map(specimen => specimen.specimenId);

        specimenIdsInBatch.forEach(batchSpecimenId => {
            var index = specimenIdsInBatches.findIndex(specimenId => specimenId === batchSpecimenId);
            if (index === -1) specimenIdsInBatches.push(batchSpecimenId);
        });
    });

    // Then create a list of specimens that aren't batched from the first list
    var patientsNotInBatches = compWellnessPatients.filter(patient => !specimenIdsInBatches.includes(patient.kitNumber));

    // Then create a list of specimens that that have not been reported as error
    var patientsNotReportedInError = patientsNotInBatches.filter(patient => (!patient.sampleErrorNote || patient.sampleErrorNote === ""));

    return patientsNotReportedInError;
}

export const AreAnyOutstandingLumiPatientsCritical = (patients: Patient[]): boolean => {
    var anyCriticalSpecimens = patients.findIndex(patient => IsOutstandingLumiPatientCritical(patient));
    return anyCriticalSpecimens !== -1;
}

export const AreAnyOutstandingCompWellnessPatientsCritical = (patients: CompWellnessPatient[]): boolean => {
    var anyCriticalSpecimens = patients.findIndex(patient => IsOutstandingCompWellnessPatientCritical(patient));
    return anyCriticalSpecimens !== -1;
}

export const IsOutstandingLumiPatientCritical = (patient: Patient) => {

    // An outstanding specimen is considered critical if it is over 3 days old
    var criticalDays = 3;

    var criticalCreationDateTime = new Date();
    criticalCreationDateTime.setDate(criticalCreationDateTime.getDate() - criticalDays);
    
    // Need to parse patient created date to Date type
    var patientCreatedDate = new Date(patient.dateCreated);

    return patientCreatedDate <= criticalCreationDateTime;
}

export const IsOutstandingCompWellnessPatientCritical = (patient: CompWellnessPatient) => {

    // An outstanding specimen is considered critical if it is over 3 days old
    var criticalDays = 3;

    var criticalCreationDateTime = new Date();
    criticalCreationDateTime.setDate(criticalCreationDateTime.getDate() - criticalDays);
    
    // Need to parse patient created date to Date type
    var patientCreatedDate = new Date(patient.dateCreated);

    return patientCreatedDate <= criticalCreationDateTime;
}